import currencyFormatter from 'currency-formatter';
import { finishedStatusList } from '../constants/commondata';
import { SUPPLIER_TYPE_VALUE } from '../containers/supplier/components/forms/formPolicy';
import { checkStatusIsSupplierAccepted, checkStatusIsSupplierAllocated } from './realTimeHelper';

export const convertDataBookingForSupplier = ({
  data,
  paramState,
  paramProps,
  supplierType
}) => {
  if (!data) return {};
  const { selectedTab } = paramState;
  const { commonData, auth } = paramProps;

  const calculatorCurrency = (value) =>
    currencyFormatter.format(parseFloat(value || 0).toFixed(2), {
      symbol: commonData?.companies[0]?.currencyISO,
    });
  let newData = {};

  if(supplierType === SUPPLIER_TYPE_VALUE.inHouse) {
    return {
      dataFare: !data?.drvInfo?.userId ? 'TBD' : calculatorCurrency(data.request?.estimate?.fare?.totalPayout),
    }
  }

  // convert data prices
  let dataFare = data?.request?.estimate?.fare?.etaFare || 0;
  if (commonData?.companies[0]?._id) {
    dataFare = data.request.estimate.fare.totalPayout;
  }

  let checkCalculateSup =
    (selectedTab == 3 || selectedTab == 0) &&
    data.request?.estimate?.fare.supplierEarningType == 'default';


  if (checkCalculateSup) {
    newData.dataFare = calculatorCurrency(
      data.request.estimate.fare.totalPayout
    );
  } else {
    newData.dataFare = calculatorCurrency(dataFare);
  }

  if (!auth?.user?.roles?.supplierPermission?.pricing) {
    newData.dataFare = '';
  }

  // convert another data

  return newData;
};

export const transformDataBooking = ({ booking, commonData, keys }) => {
  const result = {
    status: booking.status,
  };
  if (keys.includes('status')) {
    const isFinished = (booking) => {
      if (!booking) return;
      return (
        finishedStatusList.some((i) => i.value === booking.status) ||
        !!booking.finishedAt
      );
    };
    const isStatusSupplierAllocated = checkStatusIsSupplierAllocated(commonData.suppliers, booking)
    const isStatusSupplierAccepted = checkStatusIsSupplierAccepted(commonData.suppliers, booking)
    if (!isFinished(booking)) {
      result['status'] = isStatusSupplierAllocated 
        ? 'supplierAllocated' 
        : isStatusSupplierAccepted 
          ? 'supplierAccepted' 
          : booking?.status;
    }
  }

  return result;
};
